module.exports = __webpack_public_path__ + "img/new_zealand_icc.a543eb80.png";